// Configuração institucional da Associação Fados à Mesa — EDITAR AQUI sem mexer no código.
// uid: número UID quando atribuído (ex.: "CHE-123.456.789"); null mostra «Em tratamento»
// contaBancaria: IBAN quando designado (ex.: "CH93 0000 0000 0000 0000 0"); null mostra «A designar»
// moradaFamosa: morada da Pastelaria Famosa (pagamento de quotas em numerário); null mostra apenas o nome
export const ASSOC = {
    uid: "CHE-306.330.271",
    contaBancaria: null,
    moradaFamosa: null,
};
